import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { employmentSpecialRelationshipsCurrentQuery } from '@/__generated__/employmentSpecialRelationshipsCurrentQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { SurveyLayout } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { CurrentlySpecialRelationshipsContainer } from '@/components/survey/employment/special-relationships/CurrentlySpecialRelationshipsContainer';
import { specialRelationshipsCurrentQuery } from '@/graphql/query/survey/employment';
import { refundHistoryIdAtom } from '@/lib/stores/survey/common';

function SpecialRelationshipsCurrentlyPage() {
  const [queryRef, loadQuery] = useQueryLoader<employmentSpecialRelationshipsCurrentQuery>(specialRelationshipsCurrentQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const eventAttributes = useSurveyUserEventAttributes();

  useEffect(() => {
    if (refundHistoryId) {
      loadQuery({ refundHistoryId }, { fetchPolicy: 'network-only' });
    }
  }, [refundHistoryId, loadQuery]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_special-relationships-present'} eventProperty={eventAttributes}>
      <CurrentlySpecialRelationshipsContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

SpecialRelationshipsCurrentlyPage.getLayout = SurveyLayout;
export default SpecialRelationshipsCurrentlyPage;
